var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.543.92H1.873C1.163.922.588 1.498.587 2.208v8.462c.001.71.576 1.286 1.286 1.287h10.67c.71-.001 1.285-.576 1.286-1.287V2.207c0-.71-.576-1.286-1.286-1.286zM14.687 8.2l4.419 2.412v-8.32l-4.42 2.412V8.2z",
    fill: "current"
  })));
}
export default SvgVideo;